import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { ReminderConfirmDatasource } from '../datasources/create_reminder_datasource';
import { ORM } from 'utility-ts-orm';

angular
  .module('data-ng-personal-reminders')
  .factory(
    'loadReminderCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      reminderConfirmDatasource: ReminderConfirmDatasource
    ): ICommand => {
      return defineCommand('loadReminderCommand', (deferred: ng.IDeferred<IQuery[]>, reminderID: string): void => {
        $http
          .get(`event/todos/${reminderID}`)
          .then((response: any) => {
            reminderConfirmDatasource.write(response.data);
            deferred.resolve(ORM.run(reminderConfirmDatasource));
            deferred.resolve(response.data);
          })
          .catch((error: any) => {
            deferred.reject(error);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-personal-reminders/src/commands/load_reminder_command.ts